import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { cn } from '~/utils/cn';

import { Icon } from '../../atoms/Icon/view';
import { Text } from '../../atoms/Text/view';
import type { propsIconsNames } from '../../atoms/Icon/interfaces';

interface PropsHeader {
  title?: string;
  subtitle?: string;
  showBack?: boolean;
  rightIcon?: propsIconsNames;
  onClickRight?: () => void;
  onClickBack?: () => void;
  rightSlot?: ReactNode;
  className?: string;
}

export default function Header({
  title,
  subtitle,
  showBack = true,
  rightIcon,
  onClickRight,
  onClickBack,
  rightSlot,
  className,
}: PropsHeader) {
  const navigate = useNavigate();
  const back = onClickBack ?? (() => navigate(-1));

  return (
    <div
      className={cn(
        'flex items-center justify-between gap-small h-[56px] px-small bg-intense-01',
        className,
      )}
    >
      <div className="flex items-center gap-nano">
        {showBack ? (
          <button
            type="button"
            onClick={back}
            className="h-[40px] w-[40px] rounded-full bg-intense-02 flex items-center justify-center hover:opacity-80"
          >
            <Icon name="icon-chevron-left" size={20} color="#0E0D0D" />
          </button>
        ) : null}
        <div>
          {title ? (
            <Text className="text-paragraphLG color-complement-01">{title}</Text>
          ) : null}
          {subtitle ? (
            <Text className="text-captionMD color-intense-06">{subtitle}</Text>
          ) : null}
        </div>
      </div>
      {rightSlot ??
        (rightIcon ? (
          <Icon
            name={rightIcon}
            size={22}
            color="#0E0D0D"
            onClick={onClickRight}
            className="h-[40px] w-[40px]"
          />
        ) : null)}
    </div>
  );
}
